module.exports = __webpack_public_path__ + "static/media/escolha_seu_destino_titan.eaeef34a.png";